import app, { Component } from 'apprun';
export default class CommonPropertyComponent extends Component {
  state = { };
  view = (state) => {
    if (!state.item) {return;}
    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">Photo</div>
          <div><img class="col-sm-5" id="imgPreview" src={state.imgData?state.imgData:state.item.value} alt="not loaded"/></div>
          <div class="col-sm-12" >
            <br/>
            <input type="file" oninput={e => this.run('image-selected', e)} style={{ 'display': 'none' }}/>
            <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('show-OpenFileDialog')}>Upload Photo</a>
          </div>
        </div>
        <div id="imgErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs"
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {

    save: (state) => {
      if(!state.imgData) {return;}
      //if(isValidElement('inpText', state.item.validation))
      {
        state.item.value='';
        state.caller.run(state.save, state.item, state.panelId, state.imgData);
      }
    },

    'show-OpenFileDialog': () => {
      const fileInput = (document.querySelector('input[type=file]') as HTMLInputElement);
      fileInput.click();
    },

    'image-selected': (state, e) => {
      const file = e.target.files[0];
      if(file) {
        const imgErrMsg = document.getElementById('imgErrMsg') as HTMLDivElement;
        if(file.size >= 2*1024*1024) {
          imgErrMsg.innerHTML = 'image size is too big!, max size 2MB';
          return;
        } else {
          imgErrMsg.innerHTML = '';
        }
        state.reader  = new FileReader();
        state.reader.onloadend = () => this.run('image-loaded');
        state.reader.readAsDataURL(file);
      }
    },

    'image-loaded': (state) => {
      const imgData = state.reader.result;
      return { ...state, imgData };
    },

  };

  mounted = ({ state }) => state;

}
